

























import { Component, Vue, Prop } from 'vue-property-decorator';
import PersonData from '@/ts/PersonData';
import Avatar from '@/components/Media/Avatar.vue';

@Component({
    components: {
        Avatar,
    },
})
export default class ChatComment extends Vue {
    @Prop() public message: any;
    @Prop({default: false}) public forceDelete: boolean;

    get author(): PersonData {
        return this.$store.getters['User/getCacheUser'](this.message.author_id);
    }

    get authorName() {
        return this.author ? `${this.author.firstName} ${this.author.familyName}` : '';
    }

    get userId() {
        return this.$store.getters['User/getUserId'];
    }

    get timeAgo() {
        return this.$moment(this.message.created_at).local().fromNow();
    }
}
